import { html } from '~/lib/bn-lit-element';
import './import-list';
import './import-show';
import { ImportIndex } from './import-index';
import { renderIf } from '../utility/lit-entity';
import { renderRecordPreviewValue } from './helpers/import-mapping-helpers';

class UserImportIndex extends ImportIndex {
  _renderList({ href }) {
    return html`
      <import-list
        .href="${href}"
        title="User Imports"
        description="Use this page to import new users from a CSV file"
        import-show-path="/user-imports/show"
      ></import-list>
    `;
  }

  _renderImport({ href, path }) {
    return html`
      <import-show
        .href="${href}"
        .path="${path}"
        title="User Import"
        new-item-count-warning-text="New user count does not match CSV file record count. Please verify there are no duplicate entries in the file."
        .importButtonDescriptionRenderer="${this._renderImportButtonDescription}"
        .targetGroupGenerator="${this._generateTargetGroups}",
        .importPreviewRenderer="${this._renderImportPreview}",
      ></import-show>
    `;
  }

  _renderImportButtonDescription(importEntity) {
    const { newItemCount } = importEntity.properties;
    return html`<span class="item-count">${newItemCount || 0}</span> new users`;
  }

  _generateTargetGroups(importMappingEntity) {
    const mappingTargets = importMappingEntity.getSubEntities('https://api.binsentry.com/rel/mapping-target');
    const organizationTargets = [
      mappingTargets.find((target) => target.properties.target === 'organizations[department]'),
      mappingTargets.find((target) => target.properties.target === 'organizations[customer]'),
      mappingTargets.find((target) => target.properties.target === 'organizations[farm]'),
    ].filter(target => target);
    const userTargets = [
      mappingTargets.find((target) => target.properties.target === 'user[email]'),
      mappingTargets.find((target) => target.properties.target === 'user[role]'),
    ].filter(target => target);

    return [
      { name: 'Organization', targets: organizationTargets },
      { name: 'User', targets: userTargets },
    ];
  }

  _renderImportPreview({ mapping, recordPreview }) {
    const { user, organizations } = mapping;
    return html`
      ${renderIf(organizations?.department || organizations?.customer || organizations?.farm, () => html`
        <div class="properties">
          ${renderRecordPreviewValue('Department', organizations?.department, recordPreview)}
          ${renderRecordPreviewValue('Customer', organizations?.customer, recordPreview)}
          ${renderRecordPreviewValue('Farm', organizations?.farm, recordPreview)}
        </div>
      `)}
      <div class="properties">
        ${renderRecordPreviewValue('User Email', user.email, recordPreview)}
        ${renderRecordPreviewValue('User Role', user.role, recordPreview)}
      </div>
    `;
  }
}

window.customElements.define('user-import-index', UserImportIndex);
